import { useState } from "react";
import './FlexColumn.css';

const FlexColumn = ({ children, pcGap, mobileGap }) => {
	const [, setTick] = useState(0); // dummy state
	const forceUpdate = () => setTick(tick => tick + 1);

	// MediaQueryList for mobile size
	const isMobile = window.matchMedia("(max-width: 1024px)");
	const gapCache = pcGap; // whatever was passed in

	// Listen for changes in state
	isMobile.addEventListener("change", (event) => {
		if (event.matches) {
			pcGap = mobileGap;
		} else {
			pcGap = gapCache;
		}
		forceUpdate();
	});
	// Initial state
	if (isMobile.matches) {
		pcGap = mobileGap;
	}

	return (
		<div className="flexcolumn" style={{ gap: pcGap }}>
			{children}
		</div>
	);
};

export default FlexColumn;